<template>
  <div>
    <v-container :class="`grid-list-${$vuetify.breakpoint.name}`">
      <v-layout row wrap>
        <v-flex class="xs12 pa-0">
          <h2 class="nx-block-headline">{{ $t('message.milenium.selectPublication') }}</h2>
        </v-flex>
        <v-flex class="xs12 md6">
          <nx-wizard-publication-field v-model="publicationId"
                                       @change="resetFields('planilloId', 'pagePosition')"
          ></nx-wizard-publication-field>
        </v-flex>

        <v-flex class="xs12 md6">
          <nx-wizard-planillo-field :publication-id="publicationId"
                                    v-model="planilloId"
                                    :disabled="!publicationId"
                                    @change="resetFields('pagePosition')"
          ></nx-wizard-planillo-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-fade-transition>
      <v-container class="grid-list-sm" v-if="planilloId">
        <v-layout row wrap>
          <v-flex class="xs12 pa-0">
            <h2 class="nx-block-headline">{{ $t('message.milenium.selectPage') }}</h2>
            <v-progress-linear v-if="loading" indeterminate color="accent" height="4"></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!loading">
          <v-flex
            class="xs4 sm6 md4 lg3 pr-3 mb-3"
            v-for="(page, index) in availablePages"
            :key="index">
            <nx-milenium-page-image-preview :page="page"
                                            @click.native="selectPage(page)"
            ></nx-milenium-page-image-preview>
          </v-flex>

        </v-layout>
      </v-container>
    </v-fade-transition>
  </div>
</template>

<script>
import api from '@/modules/milenium/api';
import NxWizardPublicationField from '@/modules/milenium/components/wizard/steps/fields/WizardPublicationField';
import NxWizardPlanilloField from '@/modules/milenium/components/wizard/steps/fields/WizardPlanilloField';
import NxMileniumPageImagePreview from '@/modules/milenium/components/wizard/MileniumPageImagePreview';
import { delay } from '@/utils';

export default {
  components: {
    NxWizardPublicationField,
    NxWizardPlanilloField,
    NxMileniumPageImagePreview,
  },
  data() {
    return {
      loading: false,
      retryOnError: true,
      availablePages: [],
      publicationId: null,
      planilloId: null,
      pagePosition: null,
    };
  },
  methods: {
    selectPage(page) {
      this.$emit('input', { planilloId: this.planilloId, page });
    },
    resetFields(...fields) {
      fields.forEach((field) => {
        this[field] = null;
      });
    },
    async fetchPlanilloPages(planilloId) {
      this.loading = true;
      try {
        this.availablePages = await api.getPlanilloPages(planilloId);
      } catch (error) {
        console.error('Error loading milenium planillo pages', error);
        console.error('Retrying in 2 seconds...');
        await delay(2000);
        await this.fetchPlanilloPages(planilloId);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    planilloId: {
      async handler(id) {
        if (!id) {
          this.availablePages = [];
          return;
        }
        await this.fetchPlanilloPages(id);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.retryOnError = false;
  },
};
</script>
